import React, { useState } from "react";
import { globalStyle } from "../../global/Utils";
import { useDispatch, useSelector } from "react-redux";
import { addClient } from "../../Actions/AddProjectAction";
import Swal from "sweetalert2";

const AddProject = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    clientName: "",
    dbConnection: "",
    dbType: "mongo",
    domain: "",
    isActive: false,
    licenseKey: "",
    licenseExpiry: "",
    notes: "",
  });

  const isAddingClient = useSelector(
    (state) => state.AddClientReducer.isAddingClient
  );

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleDangerVisible = (err) => {
    Swal.fire({
      title: "Error",
      text: err,
      icon: "error",
      timer: 3000,
    });
  };
  const handleVisible = (msg) => {
    setFormData({
      clientName: "",
      dbConnection: "",
      dbType: "mongo",
      domain: "",
      isActive: false,
      licenseKey: "",
      licenseExpiry: "",
      notes: "",
    });
    Swal.fire({
      title: "Success",
      text: msg,
      icon: "success",
      timer: 3000,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addClient(formData, handleDangerVisible, handleVisible));
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        backgroundColor: globalStyle.bgColor,
        fontFamily: globalStyle.fontFamilyParagraph,
      }}
    >
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-lg p-8 shadow-2xl rounded-2xl"
        style={{
          backgroundColor: globalStyle.bgColorWhite,
        }}
      >
        <h2
          className="text-center font-bold mb-6"
          style={{
            fontSize: globalStyle.headingFontSizeSmall,
            color: globalStyle.curveDarkColor,
            fontFamily: globalStyle.fontFamilyHeading,
          }}
        >
          Add Client Details
        </h2>

        <div className="space-y-5">
          {/* Client Name */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700">
              Client Name
            </label>
            <input
              type="text"
              name="clientName"
              value={formData.clientName}
              onChange={handleChange}
              className="w-full px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
              style={{
                backgroundColor: "#fff",
                border: `1px solid ${globalStyle.curveLightColor}`,
              }}
              required
            />
          </div>

          {/* DB Connection */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700">
              DB Connection
            </label>
            <input
              type="text"
              name="dbConnection"
              value={formData.dbConnection}
              onChange={handleChange}
              className="w-full px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
              style={{
                backgroundColor: "#fff",
                border: `1px solid ${globalStyle.curveLightColor}`,
              }}
              required
            />
          </div>

          {/* Domain */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700">
              Domain
            </label>
            <input
              type="text"
              name="domain"
              value={formData.domain}
              onChange={handleChange}
              className="w-full px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
              style={{
                backgroundColor: "#fff",
                border: `1px solid ${globalStyle.curveLightColor}`,
              }}
              required
            />
          </div>

          {/* Is Active */}
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              name="isActive"
              checked={formData.isActive}
              onChange={handleChange}
              required
              className="w-5 h-5 accent-blue-600"
            />
            <label className="font-semibold text-gray-700">Active</label>
          </div>

          {/* License Key */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700">
              License Key
            </label>
            <input
              type="text"
              name="licenseKey"
              value={formData.licenseKey}
              onChange={handleChange}
              className="w-full px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
              style={{
                backgroundColor: "#fff",
                border: `1px solid ${globalStyle.curveLightColor}`,
              }}
            />
          </div>

          {/* License Expiry */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700">
              License Expiry
            </label>
            <input
              type="date"
              name="licenseExpiry"
              value={formData.licenseExpiry}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
              style={{
                backgroundColor: "#fff",
                border: `1px solid ${globalStyle.curveLightColor}`,
              }}
            />
          </div>

          {/* DB Type */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700">
              DataBase Type
            </label>

            <select
              name="dbType"
              value={formData.dbType}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
              style={{
                backgroundColor: "#fff",
                border: `1px solid ${globalStyle.curveLightColor}`,
              }}
            >
              <option value="mongo">MongoDB</option>
              <option value="sql">SQL</option>
            </select>
          </div>

          {/* Notes */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700">
              Notes
            </label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              className="w-full px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
              style={{
                backgroundColor: "#fff",
                border: `1px solid ${globalStyle.curveLightColor}`,
              }}
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={isAddingClient}
            className={`w-full py-3 text-white font-semibold rounded-xl shadow-lg transform transition ${isAddingClient
              ? "opacity-70 cursor-not-allowed"
              : "hover:scale-105"
              }`}
            style={{
              background: globalStyle.buttonColor,
              fontFamily: globalStyle.fontFamilyButton,
            }}
          >
            {isAddingClient ? (
              <div className="flex items-center justify-center gap-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 100 16v4l3.5-3.5L12 20v4a8 8 0 01-8-8z"
                  ></path>
                </svg>
                Submitting...
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProject;
